import React from "react";
import { TemplateWrapped } from "../../Layout";
import { ConnectionsMainContent } from "./components";

const ConnectionsDiva = ({ isChild = false }) => {
  return (
    <TemplateWrapped
      title="Insurance Verification | All Transactions"
      headerButtons={<></>}
      showTitle={false}
    >
      <div
        className="panel"
        style={{
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <div className="panel-body">
          <ConnectionsMainContent />
        </div>
      </div>
    </TemplateWrapped>
  );
};

export default ConnectionsDiva;
